import { isIOS, isMacOs, isSafari } from "react-device-detect";

const { ClipboardItem } = window;

const isCopySupported = (): boolean => {
  return Boolean(ClipboardItem) && !isIOS && !(isMacOs && isSafari);
};

export default isCopySupported;
